import { NgModule } from '@angular/core';

import { JsontestService } from './jsontest/jsontest.service';
// import { JsontestService } from 'dist/utility-lib/lib/jsontest/jsontest.service';
// import { JsontestService } from './jsontest/jsontest.module';

import { UtilityLibComponent } from './utility-lib.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    HttpClientModule,
  ],
  declarations: [
    UtilityLibComponent
  ],
  providers: [
    JsontestService
  ],
  exports: [
    UtilityLibComponent,
  ]
})
export class UtilityLibModule { }
